package net.sergeych.ugdx.shared

import net.sergeych.kiloparsec.command

/**
 * Deprecated("Use ApiCommand for new commands")
 */

val cmdCheckInviteCode by command<String,Boolean>()
val cmdGetCurrencies by command<Unit,GetCurrenciesResult>()
val cmdGetEthSignatureMessage by command<GetEthSignatureMessageArgs,GetEthSignatureMessageResult>()
val cmdDeleteTestUser by command<String,Boolean>()

